import * as Yup from "yup";
import { useTranslation } from "react-i18next";

const useCongratsSchema = () => {
  const { t } = useTranslation();
  return Yup.object().shape({
    full_name: Yup.string().required(t("full_name_required")),
  });
};

export default useCongratsSchema;
